import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import { LoginScreen } from './components/auth/LoginScreen';
import { Shell } from './components/shell/Shell';
import { AuthProvider, useAuth } from './lib/auth';
import { Bots } from './pages/Bots';
import { Clientes } from './pages/Clientes';
import { Metricas } from './pages/Metricas';
import { Parceiros } from './pages/Parceiros';
import { PartnerDetail } from './pages/PartnerDetail';
import { Ranking } from './pages/Ranking';
import { Saude } from './pages/Saude';
import { Tickets } from './pages/Tickets';
import { Usuarios } from './pages/Usuarios';
import { VisaoGeral } from './pages/VisaoGeral';

function Gate() {
  const { status } = useAuth();

  if (status !== 'logged_in') return <LoginScreen />;

  return (
    <Routes>
      <Route element={<Shell />}>
        <Route index element={<VisaoGeral />} />
        <Route path="metricas" element={<Metricas />} />
        <Route path="parceiros" element={<Parceiros />} />
        <Route path="parceiros/:id" element={<PartnerDetail />} />
        <Route path="ranking" element={<Ranking />} />
        <Route path="clientes" element={<Clientes />} />
        <Route path="tickets" element={<Tickets />} />
        <Route path="bots" element={<Bots />} />
        <Route path="saude" element={<Saude />} />
        <Route path="usuarios" element={<Usuarios />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Route>
    </Routes>
  );
}

export function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <Gate />
      </AuthProvider>
    </BrowserRouter>
  );
}
